<div class="bg-page text-fg">
  <header class="fixed inset-x-0 top-0 z-50 h-16 border-b border-border bg-card/80 backdrop-blur-sm">
    <div class="mx-auto w-[min(1280px,calc(100%-3rem))] max-[700px]:w-[calc(100%-1.25rem)] flex h-full items-center justify-between gap-6">
      <a href="/#">
        <img src="main_money_full.png" alt="MainMoney" class="h-7 w-auto" />
      </a>
      <nav class="flex items-center gap-8 max-[1100px]:hidden">
        <a class="text-[0.9rem] font-semibold text-muted no-underline transition-colors hover:text-primary" routerLink="/" fragment="services">Services</a>
        <a class="text-[0.9rem] font-semibold text-muted no-underline transition-colors hover:text-primary" routerLink="/" fragment="coverage">Coverage</a>
        <a class="text-[0.9rem] font-semibold text-muted no-underline transition-colors hover:text-primary" routerLink="/" fragment="technical">Technical</a>
        <a class="text-[0.9rem] font-semibold text-muted no-underline transition-colors hover:text-primary" routerLink="/" fragment="pricing">Pricing</a>
      </nav>
      <div class="flex flex-wrap items-center gap-3">
        <ui-theme-toggle />
        @if (isAuthenticated()) {
          <a routerLink="/app" uiButton variant="primary" class="rounded-xl shadow-lg">Dashboard</a>
        } @else {
          <a routerLink="/login" class="text-[0.88rem] font-semibold text-muted no-underline hover:text-primary max-[700px]:hidden">Login</a>
          <a routerLink="/login" uiButton variant="primary" class="rounded-xl shadow-lg">Get Started</a>
        }
      </div>
    </div>
  </header>

  <main class="pt-16">
    <router-outlet />
  </main>

  <footer class="border-t border-border bg-card pt-12">
    <div class="mx-auto w-[min(1280px,calc(100%-3rem))] max-[700px]:w-[calc(100%-1.25rem)] grid grid-cols-[1.6fr_1fr_1fr_1fr] gap-5.5 max-[1100px]:grid-cols-2 max-[700px]:grid-cols-1">
      <div>
        <img src="main_money_full.png" alt="MainMoney" class="h-7 w-auto" />
        <p class="mt-4 text-[0.9rem] leading-relaxed text-muted">
          The leading payment infrastructure provider for Central Africa. Empowering businesses to reach every customer,
          everywhere.
        </p>
      </div>
      <div>
        <h5 class="mb-4 text-[0.72rem] font-semibold tracking-[0.08em] text-fg uppercase">Product</h5>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/" fragment="services">Features</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/" fragment="pricing">Pricing</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/" fragment="coverage">Coverage Map</a>
      </div>
      <div>
        <h5 class="mb-4 text-[0.72rem] font-semibold tracking-[0.08em] text-fg uppercase">Resources</h5>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/api-docs">API Docs</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/sdk-library">SDK Library</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" href="mailto:business@mainmoney.net" target="_blank" rel="noopener">Support</a>
      </div>
      <div>
        <h5 class="mb-4 text-[0.72rem] font-semibold tracking-[0.08em] text-fg uppercase">Legal</h5>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/terms-and-conditions">Terms and Conditions</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/privacy-policy">Privacy Policy</a>
        <a class="my-1.5 block text-[0.9rem] text-muted no-underline hover:text-primary" routerLink="/cookie-policy">Cookie Policy</a>
      </div>
    </div>
    <div class="mx-auto w-[min(1280px,calc(100%-3rem))] max-[700px]:w-[calc(100%-1.25rem)] mt-8 flex items-center justify-between gap-4 border-t border-border pt-4.5 pb-6 text-[0.85rem] text-muted max-[700px]:flex-col max-[700px]:items-start">
      <p class="m-0">© {{ year }} MainMoney Aggregator. All rights reserved.</p>
      <div class="inline-flex items-center gap-1.5 rounded-full border border-success-border bg-success-bg px-2.5 py-1.5 text-[0.65rem] font-bold tracking-widest text-success-fg uppercase">
        <span class="status-dot size-2 rounded-full bg-success"></span>All Systems Operational
      </div>
    </div>
  </footer>
</div>
